import { Component, ViewEncapsulation, Input } from '@angular/core';
import { LicenseStorage } from '@portal-core/license-storage/models/license-storage.model';
import { NgIf } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar';
import { FileSizePipe } from '@portal-core/general/pipes/file-size/file-size.pipe';

@Component({
    selector: 'mc-storage-usage-bar',
    templateUrl: './storage-usage-bar.component.html',
    styleUrls: ['./storage-usage-bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf, MatProgressBar, FileSizePipe]
})
export class StorageUsageBarComponent {
  @Input() licenseStorage: LicenseStorage;
  @Input() trialLicense: boolean;
}
